import React from 'react';

export function StoneStepper({ value, onChange }) {
  const handleMinus = () => {
    const newValue = Math.max(0, (parseInt(value) || 0) - 1);
    onChange(newValue);
  };

  const handlePlus = () => {
    const newValue = Math.max(0, (parseInt(value) || 0) + 1);
    onChange(newValue);
  };

  const handleInputChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, '');
    onChange(val === '' ? '' : parseInt(val) || 0);
  };

  const handleBlur = () => {
    const numVal = parseInt(value) || 0;
    onChange(Math.max(0, numVal));
  };

  const handleFocus = (e) => {
    if (value === 0 || value === '0') {
      onChange('');
    }
    const input = e.target;
    requestAnimationFrame(() => input.setSelectionRange(input.value.length, input.value.length));
  };

  return (
    <div className="stone-stepper">
      <button type="button" className="stone-stepper-btn minus" onClick={handleMinus}>−</button>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
      <button type="button" className="stone-stepper-btn plus" onClick={handlePlus}>+</button>
    </div>
  );
}
